import script from "./PercentDigit.vue?vue&type=script&setup=true&lang=js"
export * from "./PercentDigit.vue?vue&type=script&setup=true&lang=js"

import "./PercentDigit.vue?vue&type=style&index=0&id=f6bb9182&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6bb9182"]])

export default __exports__